import { useEffect, useRef } from 'react'
import {
  NotificationType,
  UserNotification,
} from '../../../store/use-notifications'

const statusIconStyles: Record<
  NotificationType,
  { text: string; bg: string; icon: string }
> = {
  success: {
    text: 'tw-text-success',
    bg: 'tw-bg-success-100',
    icon: 'fa-check',
  },
  info: {
    text: 'tw-text-primary',
    bg: 'tw-bg-primary-100',
    icon: 'fa-check',
  },
  warning: {
    text: 'tw-text-secondary',
    bg: 'tw-bg-secondary-100',
    icon: 'fa-triangle-exclamation',
  },
  danger: {
    text: 'tw-text-danger',
    bg: 'tw-bg-danger-100',
    icon: 'fa-triangle-exclamation',
  },
}

export default function Notification({
  notification,
  onDismiss,
}: {
  notification: UserNotification
  onDismiss: () => void
}) {
  const timer = useRef<NodeJS.Timeout>()
  useEffect(() => {
    if (!notification) return
    timer.current = setTimeout(() => {
      onDismiss()
    }, 5000)
    return () => timer.current && clearTimeout(timer.current)
  })

  const type = notification?.type
  const { text, bg, icon } = statusIconStyles[type] || {
    text: '',
    bg: '',
    icon: '',
  }

  return notification ? (
    <div className="tw-absolute tw-bottom-2 tw-right-2 tw-z-messages">
      <div
        className="tw-flex tw-items-start tw-p-4 tw-mb-4 tw-w-full tw-max-w-xs tw-text-gray-500 tw-bg-white tw-border tw-border-system-grey-200 tw-rounded tw-shadow-lg tw-opacity-80 hover:tw-opacity-100 tw-transition-opacity tw-duration-200"
        role="alert"
        onClick={onDismiss}>
        <div
          className={`tw-inline-flex tw-flex-shrink-0 tw-justify-center tw-items-center tw-w-8 tw-h-8 ${text} ${bg} tw-rounded-lg`}>
          <i className={`fas ${icon}`} />
        </div>
        <div className="tw-ml-3 tw-text-sm tw-font-normal">
          {notification.html}
        </div>
      </div>
    </div>
  ) : null
}
